/* Dynoforce, de 17:00-teller.

   Staat alleen onder artikelen die echt in Elburg liggen. Voor alles wat
   besteld moet worden zegt de regel erboven al genoeg en zou een teller een
   belofte doen die we niet waar kunnen maken.

   De tijd komt van de klok van de bezoeker, omgerekend naar Europe/Amsterdam
   met Intl. Daarmee gaat de zomertijd vanzelf goed en hoeft er niets van de
   server te komen, wat belangrijk is omdat Shopify pagina's kan cachen en een
   meegestuurde servertijd dan oud kan zijn. Staat de klok van de bezoeker
   verkeerd, dan klopt de teller niet; dat is niet op te lossen zonder een
   extra verzoek en het weegt niet op tegen de winst.

   Elke minuut bijwerken. Een teller die per seconde wegtikt jaagt op. */

(function () {
  var DAGEN = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

  function delen(datum) {
    var f = new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'Europe/Amsterdam',
      weekday: 'long', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    });
    var d = {};
    f.formatToParts(datum).forEach(function (p) { d[p.type] = p.value; });
    /* Middernacht komt er bij hour12:false uit als 24, niet als 00. */
    if (d.hour === '24') d.hour = '00';
    return {
      dag: DAGEN.indexOf(d.weekday),
      datum: d.year + '-' + d.month + '-' + d.day,
      minuten: parseInt(d.hour, 10) * 60 + parseInt(d.minute, 10),
      naam: d.weekday
    };
  }

  function duur(minuten) {
    var u = Math.floor(minuten / 60);
    var m = minuten % 60;
    var mTekst = m === 1 ? '1 minuut' : m + ' minuten';
    if (u === 0) return mTekst;
    var uTekst = u === 1 ? '1 uur' : u + ' uur';
    if (m === 0) return uTekst;
    return uTekst + ' en ' + mTekst;
  }

  function vul(sjabloon, waarden) {
    return sjabloon.replace(/\{(\w+)\}/g, function (_, k) {
      return waarden[k] == null ? '' : waarden[k];
    });
  }

  /* De regel boven de teller belooft "morgen in huis". Dat klopt alleen zolang
     de bestelling vandaag nog weggaat. Is het na 17:00 uur of is het weekend,
     dan korten we die regel in tot het deel voor de eerste komma en vertelt de
     teller wanneer het pakket echt vertrekt.

     Inkorten op de komma in plaats van een tweede zin in een instelling: de
     zin komt uit snippets/df-levertijd en past zich zo vanzelf aan als hij
     daar wordt gewijzigd. Staat er geen komma in, dan blijft de zin heel.

     Zonder JavaScript blijft de hele zin staan; dan is er ook geen teller die
     hem kan tegenspreken. */
  function zetRegel(el, binnenVenster) {
    var zin = el.parentElement && el.parentElement.querySelector('[data-df-pk-vrd-zin]');
    if (!zin) return;
    if (!el.dataset.regelBinnen) el.dataset.regelBinnen = zin.textContent.trim();
    var heel = el.dataset.regelBinnen;
    var kort = el.dataset.regelBuiten || heel.split(',')[0].trim();
    zin.textContent = binnenVenster ? heel : kort;
  }

  function werk(el) {
    /* Uit gezet omdat dit artikel besteld moet worden: dan hoort er geen
       teller onder te staan. */
    if (el.dataset.aan !== 'ja') { el.hidden = true; el.textContent = ''; return; }

    var verzenddagen = (el.dataset.verzenddagen || '1,2,3,4,5')
      .split(',').map(function (x) { return parseInt(x.trim(), 10); });
    var feestdagen = (el.dataset.feestdagen || '')
      .split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    var afkap = parseInt(el.dataset.afkap || '1020', 10);

    function verzendt(d) {
      return verzenddagen.indexOf(d.dag) > -1 && feestdagen.indexOf(d.datum) === -1;
    }

    var nu = new Date();
    var vandaag = delen(nu);

    if (verzendt(vandaag) && vandaag.minuten < afkap) {
      el.textContent = vul(el.dataset.vandaag || 'Nog {tijd}, dan wordt het vandaag verstuurd',
        { tijd: duur(afkap - vandaag.minuten) });
      el.hidden = false;
      zetRegel(el, true);
      return;
    }

    /* Volgende verzenddag zoeken. Veertien dagen vooruit is ruim genoeg, ook
       met een rij feestdagen achter elkaar. Wordt er niets gevonden, dan laten
       we de teller weg en blijft de vaste regel erboven staan. */
    for (var n = 1; n <= 14; n++) {
      var d = delen(new Date(nu.getTime() + n * 86400000));
      if (!verzendt(d)) continue;
      var sjabloon = n === 1
        ? (el.dataset.morgen || 'Voor morgen 17:00 uur besteld, dan wordt het {dag} verstuurd')
        : (el.dataset.dag || 'Besteld voor {dag} 17:00 uur, dan wordt het {dag} verstuurd');
      el.textContent = vul(sjabloon, { dag: d.naam });
      el.hidden = false;
      zetRegel(el, false);
      return;
    }
    el.hidden = true;
    zetRegel(el, true);
  }

  function alles() {
    document.querySelectorAll('[data-df-lt-teller]').forEach(werk);
  }

  function start() {
    if (window.__dfLevertijd) return;
    window.__dfLevertijd = true;
    if (!window.Intl || !Intl.DateTimeFormat || !Intl.DateTimeFormat.prototype.formatToParts) return;
    alles();
    /* Op de minuut mee, niet elke zestig seconden vanaf nu. Anders loopt de
       teller na een uur zichtbaar achter op de klok. */
    var naarMinuut = (60 - new Date().getSeconds()) * 1000 + 50;
    window.setTimeout(function () {
      alles();
      window.setInterval(alles, 60000);
    }, naarMinuut);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* Na een variantwissel zet df-product de regel opnieuw; dan moet de teller
     ook opnieuw. */
  document.addEventListener('df:levertijd', alles);
})();
